/* eslint-disable react/prop-types */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { useHistory } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { Button, ContentCard, ModalGeneric, Table } from 'ypf-pas-general-ui-components';
import { BsPlusCircle, BsTrash } from 'react-icons/bs';

import { ReactComponent as FileImg } from '../../../assets/images/icon-upload.svg';
import { deleteFilesRequestSDS } from '../../../services/serviceRequestAttachment';
import { deleteFileTemplateRequest } from '../../../services/templateServiceRequest';
import useToast from '../../../hooks/useToast';
import { useFilesContext } from '../../../context/FilesProvider';
import { formatDate } from '../../../utils/formatUtils';
import LoaderContext from '../../../context/LoaderProvider';
import { stepEnum, stepEnumOfAccordion } from '../Constants';
import { RequestField } from '../CreateServiceProps';
import { MAX_FILE_SIZE } from '../../../constants/constants';
import './Files.scss';

const Files = ({
  step,
  requestField,
  accordionId,
  serviceRequestId,
  templateRequestId,
  disabledAllFields
}) => {
  const history = useHistory();
  const { setNewToast } = useToast();
  const { setLoader } = useContext(LoaderContext);
  const [select, setSelect] = useState([]);
  const [disabledButtons, setDisabledButtons] = useState(true);
  const [showModalDelete, setShowModalDelete] = useState(false);

  const { values, setFieldValue } = useFormikContext();

  const containerRef = useRef();

  const {
    attachmentsByAccordion,
    setAccordionAttachments,
    getAccordionAttachments,
    onDrop,
    onDropAccepted
  } = useFilesContext();

  const isCreate = history.location.pathname.includes('createMultiple');
  const isCreateTemplate = history.location.pathname.includes('generate-template/request');

  const accordionAttachments = useMemo(
    () => getAccordionAttachments(accordionId),
    [attachmentsByAccordion[accordionId]]
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    onDropAccepted,
    maxSize: MAX_FILE_SIZE,
    noClick: true,
    noKeyboard: true,
    accept: 'pdf,.PDF,.jpg,.JPG,.jpeg,.JPEG,.msg,.xls,.xlsx,.png,.doc,.docx,.pptx,.ppt'
  });

  const handleChangeSelect = (item) => {
    if (select.includes(item)) {
      const newSelect = select.filter((name) => name !== item);

      setSelect(newSelect);

      return;
    }
    setSelect([...select, item]);
  };

  const selectAll = () => {
    if (select.length < accordionAttachments?.length) {
      const ids = accordionAttachments?.map((item) => item.id);

      setSelect(ids);
    } else {
      setSelect([]);
    }
  };

  const deleteAdjuntos = async () => {
    setLoader(true);
    if (!serviceRequestId || isCreateTemplate || isCreate) {
      const selectLength = select.length;
      const newFiles = accordionAttachments.filter((item) => !select.includes(item.id));

      setAccordionAttachments(accordionId, newFiles);
      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message:
          selectLength > 1 ? 'Archivos eliminados con éxito.' : 'Archivo eliminado con éxito.'
      });
      setSelect([]);
      setLoader(false);
    } else {
      try {
        let response;

        if (templateRequestId) {
          response = await deleteFileTemplateRequest(templateRequestId, select);
        } else {
          response = await deleteFilesRequestSDS(serviceRequestId, select);
        }
        if (response?.success || response?.mensaje) {
          setNewToast({
            type: 'SUCCESS',
            message: `Archivo(s) eliminado con éxito.`
          });
        }
        const newFiles = accordionAttachments.filter((item) => !select.includes(item.id));

        setAccordionAttachments(accordionId, newFiles);
        setSelect([]);
        setLoader(false);
      } catch (err) {
        setLoader(false);
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
      }
    }
  };

  const sizeFile = ({ value }) => {
    const valueMb = Math.round(value / 1024);

    return `${valueMb} MB`;
  };

  useEffect(() => {
    if (select.length > 0) {
      setDisabledButtons(false);
    }
    if (select.length === 0) setDisabledButtons(true);
  }, [accordionAttachments, select]);

  useEffect(() => {
    if (step === stepEnumOfAccordion.files) {
      containerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      setFieldValue(`${requestField}.accordionStep`, stepEnumOfAccordion.files);
    }

    if (accordionAttachments?.length)
      setFieldValue(`${requestField}.attachments`, accordionAttachments);
  }, [step, serviceRequestId, accordionAttachments]);

  useEffect(() => {
    if (!accordionAttachments?.length) setAccordionAttachments(accordionId, []);
  }, []);

  const justify = {
    textAlign: 'center',
    padding: 20
  };

  const columnsAdjuntos = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.length === accordionAttachments?.length}
            disabled={disabledAllFields}
            onChange={selectAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de Archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.includes(row.original.id)}
            disabled={disabledAllFields}
            onChange={() => handleChangeSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    }
  ];

  const columnsAdjuntosEdit = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.length === accordionAttachments?.length}
            disabled={disabledAllFields}
            onChange={selectAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de Archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.includes(row.original.id)}
            disabled={disabledAllFields}
            onChange={() => handleChangeSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Fecha de subida',
      accessor: 'fechaSubida',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    }
  ];

  return (
    <div ref={containerRef}>
      <ContentCard
        mark={
          values.currentStep >= stepEnum.services && step === stepEnumOfAccordion.files
            ? 'primary'
            : 'none'
        }
        orientation="horizontal-vertical"
      >
        <div className="d-flex align-items-center justify-content-between">
          <h6>Archivos de la solicitud</h6>
          <div className="d-flex buttons-files">
            <Button
              colorIcon="danger"
              disabled={disabledButtons}
              icon={BsTrash}
              onClick={() => setShowModalDelete(true)}
              type="button"
              variant="light-gray"
              widthButton="45px"
            />

            <div {...getRootProps()}>
              <input
                {...getInputProps()}
                accordionid={accordionId}
                isDraw={isCreateTemplate && serviceRequestId}
                servicerequestid={serviceRequestId}
                templateRequestId={templateRequestId}
                value={undefined}
                // Esto quiere decir que la plantilla se esta creando a partir de un borrador
              />
              <Button
                colorIcon="primary"
                disabled={disabledAllFields}
                fontSizeLabel="15px"
                icon={BsPlusCircle}
                iconRight
                label="Agregar adjunto"
                onClick={open}
                sizeIcon="17px"
                type="button"
                variant="light-gray"
                widthButton="180px"
              />
            </div>
          </div>
        </div>
        <hr />
        {accordionAttachments?.length === 0 && (
          <div className="mt-5 d-flex justify-content-center align-items-center flex-column">
            <FileImg />
            <h6 className="mt-3">No disponés de ningún archivo adjunto</h6>
          </div>
        )}
        {accordionAttachments?.length > 0 && (
          <Table
            columns={isCreate ? columnsAdjuntos : columnsAdjuntosEdit}
            data={accordionAttachments}
            type="light"
          />
        )}
      </ContentCard>
      <ModalGeneric
        backdrop
        primaryAction={() => {
          deleteAdjuntos();
          setShowModalDelete(false);
        }}
        primaryActionLabel="Aceptar"
        secondaryAction={() => setShowModalDelete(false)}
        secondaryActionLabel="Cancelar"
        show={showModalDelete}
        size="md"
      >
        <p>¿Está seguro que desea eliminar el archivo?</p>
      </ModalGeneric>
    </div>
  );
};

Files.propTypes = {
  disabledAllFields: RequestField.bool,
  requestField: RequestField.isRequired,
  accordionId: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  serviceRequestId: PropTypes.number.isRequired,
  templateRequestId: PropTypes.number.isRequired
};

Files.defaultProps = {
  disabledAllFields: false
};

export default Files;
